import { Auth } from 'aws-amplify';

function fixBase64Encoding(base64String) {
    if (!base64String) return "";
    return base64String.replace(/-/g, '+').replace(/_/g, '/');
}

export async function refresh_token() {
    try {
        const tokenId = sessionStorage.getItem("getIdTokenRefresh");
        const tokenAcces = sessionStorage.getItem("getAccesTokenRefresh");

        if (!tokenId || !tokenAcces) {
            console.error("Token not found in sessionStorage");
            return false;
        }

        let decodedToken;
        let decodedAccessToken;
        try {
            decodedToken = JSON.parse(atob(fixBase64Encoding(tokenId.split('.')[1])));
            decodedAccessToken = JSON.parse(atob(fixBase64Encoding(tokenAcces.split('.')[1])));
        } catch (e) {
            // await Auth.signOut();
            alert("Sesión terminada.");
            // window.location.href = "/";
            return false;
        }

        const expirationDate = new Date(0);
        expirationDate.setUTCSeconds(decodedToken.exp);
        const expirationDateAcces = new Date(0);
        expirationDateAcces.setUTCSeconds(decodedAccessToken.exp);

        const currentTime = new Date();
        const timeToRefresh = (expirationDate - currentTime) / 1000 / 60;


        if (timeToRefresh <= 15) {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const { refreshToken } = cognitoUser.getSignInUserSession();
            cognitoUser.refreshSession(refreshToken, (err, session) => {
                if (err) {
                    console.error("Error refreshing token", err);
                    return;
                }
                sessionStorage.setItem("getIdTokenRefresh", session?.idToken?.jwtToken);

            });

            return true;
        } else {

            if (expirationDateAcces < currentTime) {
                try {
                    // await Auth.signOut();
                    // alert("Sesión terminada.");
                    // window.location.href = "/";
                } catch (error) {
                    console.log("Error al cerrar sesión:", error);
                }
                console.log("Session Terminada.");
                return false;
            } else {
                return true;
            }
        }
    } catch (error) {
        console.log(`Error: ${error}`);
        try {
            // await Auth.signOut();
            alert("Sesión terminada.");
            // window.location.href = "/";
        } catch (error) {
            console.log("Error al cerrar sesión:", error);
        }
    }
}
